import React, { ReactNode } from "react";
import styles from "./JokerVideoHeader.module.css";
import TwoToneHeading, {
  TwoToneHeadingTextAlign,
  TwoToneHeadingTextSize,
} from "../TwoToneHeading";
import Paragraph, { ParagraphSize } from "../Paragraph";
import ImageComponent from "../ImageComponent";
import DownloadTagComponent from "../../pages/Download/component/DownloadTagComponent";
import { motion } from "framer-motion";
import { getResponsiveBgImage } from "../../util/ExtensionFunction";

interface JokerProHeaderProps {
  headerText: string;
  title: string;
  highlightLabel: string;
  description: string;
  bgImage?: string[];
  bgGradientStyle?: string;
  image?: string[];
  isDownloadTagNotVisible?: boolean;
  children: ReactNode;
}

const JokerProHeader = ({
  headerText,
  title,
  highlightLabel,
  description,
  bgImage,
  image,
  isDownloadTagNotVisible = false,
  children,
}: JokerProHeaderProps) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{
      type: "spring",
      stiffness: 96,
      damping: 30,
    }}
  >
    <div className={styles["main-container"]}>
      <div
        className={styles["video-container"]}
        style={{
          backgroundImage: `
        linear-gradient(to top, rgba(0,0,0, 0.75), rgba(0, 0, 0, 0)),
        url(${getResponsiveBgImage(bgImage)})
      `,
        }}
      >
        <div className={styles["information-view-container"]}>
          <div className={`${styles["header"]}`}>
            <Paragraph
              size={ParagraphSize.paragraph2}
              classNameStyle={styles["heading-color"]}
            >
              {headerText}
            </Paragraph>

            <TwoToneHeading
              primaryText={title}
              secondaryText={highlightLabel}
              textAlign={TwoToneHeadingTextAlign.left}
              textSize={TwoToneHeadingTextSize.heading2}
              isGoldColor
            />
            <Paragraph
              size={ParagraphSize.paragraph1}
              classNameStyle={styles["header-description"]}
            >
              {description}
            </Paragraph>
          </div>

          <div className={styles["card-container"]}>{children}</div>
        </div>
        {image && (
          <div className={styles["image-container"]}>
            <ImageComponent src={image} className={styles["image-view"]} />
          </div>
        )}
        <div className={styles["bottom-gradient"]} />
      </div>

      {!isDownloadTagNotVisible && (
        <motion.div
          className={styles["download-container"]}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.4 }}
        >
          <DownloadTagComponent />
        </motion.div>
      )}
    </div>
  </motion.div>
);

export default JokerProHeader;
